/** Created by azhou on 2019/3/22.*/
<template>
  <div>
    <public-title>账号列表
      <div class="ml-auto" slot="right">
        <el-button size="small" type="success" @click="addStaff">添加账号</el-button>
      </div>
    </public-title>
    <p v-if="staffLists.total<=0">当前没有数据</p>
    <div v-else>
      <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
      <ul class="list-item" v-for="Itemize in staffLists.lists" :key="Itemize.id">
        <li class="w-50 list-item-col">{{Itemize.username}}</li>
        <li class="w-50 list-item-col">{{Itemize.truename}}
          <span class="ml-1" :class="Itemize.status ? 'text-success' : 'text-danger'">{{Itemize.status ? '[启用中]':'[禁用中]'}}</span>
        </li>
        <li class="w-50 list-item-col">{{Itemize.mobile}}</li>
        <li class="w-50 list-item-col" :class="[Itemize.wechat_openid ?'text-success':'text-danger']">
          {{Itemize.wechat_openid ? '已绑定':'未绑定'}}
        </li>
        <li class="w-50 list-item-col">{{Itemize.name}}</li>
        <li class="w-50 list-item-col">
          已登录 {{Itemize.num}} 次
          <el-tooltip class="ml-1" effect="dark"  placement="right" v-show="Itemize.login_time">
            <div slot="content">
              <p class="mb-2">上次登录IP：{{Itemize.ip}}</p>
              <p>上次登录时间：{{Itemize.login_time | formatTimestamp(1)}}</p>
            </div>
            <i class="el-icon-info"></i>
          </el-tooltip>
        </li>
        <li class="w-50 list-item-col flex-wrap">
          <span class="text-link mr-2" @click="showAccessFun(Itemize)">查看权限</span>
          <span class="text-link" @click="editItem(Itemize)">编辑信息</span>
        </li>
      </ul>
      <el-pagination background layout="prev, pager, next" class="mt-4"
                     :total="staffLists.total" :current-page="Number(queryCon.page)"
                     @current-change="$GFUN.pageChange"/>
    </div>
    <!--账号权限-->
    <el-dialog title="账号权限" :visible.sync="showAccess" center>
      <el-tree :data="powerArr" :props="defaultProps" />
      <el-button type="primary" @click="showAccess = false" slot="footer">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'

  export default {
    name: 'AdminManage',
    computed: {
      ...mapState(['staffLists','positionDetail']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      powerArr() { return this.positionDetail.power_arr }
    },
    watch:{
      queryCon() { this.getUserStaffLists(this.queryCon); },
    },
    data() {
      return {
        titleArr:['工号','姓名','手机号','微信','职位名称','登录信息','操作'],
        showAccess:false,           //展示账号权限
        defaultProps: {
          children: 'children',
          label: 'title'
        },
        accountStore:[],            //账号管理的门店列表
      }
    },
    created() {
      this.getUserStaffLists();
    },
    methods:{
      ...mapActions(['getUserStaffLists','getPositionDetail']),
      //跳转到添加账号
      addStaff() {
        if (!this.$GFUN.powerIsInArray([117])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({name:'addEditAdmin'})
      },
      //跳转到编辑账号
      editItem(item) {
        if (!this.$GFUN.powerIsInArray([115])) { this._alert('您没有相关权限！',null,'error'); return; }
        let query = {
          account:item.id,
          username:item.username,
          truename:item.truename,
          mobile:item.mobile,
          status:item.status,
          position_id:item.position_id,
        }
        this.$router.push({name:'addEditAdmin',query})
      },
      //查看账号权限
      showAccessFun(item) {
        if (!this.$GFUN.powerIsInArray([114])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.getPositionDetail(item.position_id);
        this.showAccess = true;
      },
    },
  }
</script>
